/*
 * scroll-hint.js — Mobile only
 * Persistent scroll-indicator bar for all scrollable containers
 */
(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  var SEL = '.mounjaro-compare, .wegovy-compare, .saxenda-compare, .dosierung-schema, .tvlS__chart, .tvlW__chart, .tvlauf__chart';

  function init() {
    document.querySelectorAll(SEL).forEach(function (container) {
      if (container.dataset.scrollHint) return;
      container.dataset.scrollHint = '1';
      if (container.scrollWidth <= container.clientWidth + 5) return;

      var track = document.createElement('div');
      track.className = 'scroll-indicator-track';

      var thumb = document.createElement('div');
      thumb.className = 'scroll-indicator-thumb';
      track.appendChild(thumb);

      container.parentNode.insertBefore(track, container.nextSibling);

      function updateThumb() {
        var ratio = container.clientWidth / container.scrollWidth;
        var thumbW = Math.max(ratio * 100, 20);
        var maxScroll = container.scrollWidth - container.clientWidth;
        var scrollRatio = maxScroll > 0 ? container.scrollLeft / maxScroll : 0;
        var thumbLeft = scrollRatio * (100 - thumbW);

        thumb.style.width = thumbW + '%';
        thumb.style.left = thumbLeft + '%';
      }

      container.addEventListener('scroll', updateThumb, { passive: true });
      updateThumb();
    });
  }

  init();
  window.addEventListener('load', init);
  setTimeout(init, 2000);
})();
